import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/id/sharing/page';

export const Route = createFileRoute('/_app/_chat/skills/$id/sharing/')({
  component: Page,
});
